export default __webpack_public_path__ + "static/media/new_login_bg.b2ebf47c.png";